<div
  class=" filter-container mb-4 flex flex-col gap-2 rounded-lg border p-6 filters-shadow"
  (click)="onContainerClick($event)">
  <div class="grid grid-cols-3 gap-6 border-b section-border pt-4 pb-6">
    <app-filter-input [label]="isArabic() ? 'اسم الخط' : 'Route Name'" [(value)]="routeName"></app-filter-input>

    <app-filter-product-search
      [label]="isArabic() ? 'اسم الموزع' : 'Distributor'"
      [placeholder]="isArabic() ? 'ابحث باسم الموزع...' : 'Search by distributor name'"
      [loading]="distributorLoading()"
      [error]="distributorError()"
      [results]="distributorResults()"
      [(searchTerm)]="distributorSearchTerm"
      [(showDropdown)]="showDistributorDropdown"
      (searchChange)="onDistributorSearchChange($event)"
      (selectItem)="onDistributorSelect($event)"></app-filter-product-search>

    <app-filter-multi-select
      [label]="{ titleAr: 'المحافظة', titleEn: 'Governorate' }"
      [placeholder]="{ titleAr: 'اختر المحافظة', titleEn: 'Choose Governorate' }"
      [items]="governorateOptions()"
      [(selectedIds)]="selectedGovernorateIds"
      [showDropdown]="showGovernorateDropdown()"
      (toggleDropdown)="toggleGovernorateDropdown()"
      (selectionChange)="onGovernorateChange($event)"></app-filter-multi-select>

    <app-filter-select-component
      [label]="isArabic() ? 'المدينة' : 'City'"
      [defaultOption]="isArabic() ? 'كل المدن' : 'All Cities'"
      [options]="cityOptions()"
      [(value)]="selectedCityId"
      (valueChange)="onCityChange($event)"></app-filter-select-component>

    <app-filter-select-component
      [label]="isArabic() ? 'المنطقة' : 'Region'"
      [defaultOption]="isArabic() ? 'كل المناطق' : 'All Regions'"
      [options]="regionOptions()"
      [(value)]="selectedRegionId"></app-filter-select-component>

    <app-filter-select-component
      [label]="isArabic() ? 'عدد الطلبات' : 'Orders Count'"
      [defaultOption]="isArabic() ? 'الكل ' : 'All '"
      [options]="ordersCountOptions()"
      [(value)]="selectedOrdersCount"></app-filter-select-component>
    <app-filter-select-component
      [label]="isArabic() ? 'عدد الصيدليات' : 'Pharmacies Count'"
      [defaultOption]="isArabic() ? 'الكل ' : 'All '"
      [options]="pharmaciesCountOptions()"
      [(value)]="selectedPharmaciesCount"></app-filter-select-component>

    <app-filter-multi-select
      [label]="{ titleAr: 'الحالات', titleEn: 'Status' }"
      [items]="statusOptions()"
      [(selectedIds)]="selectedStatusIds"
      [showDropdown]="showStatusDropdown()"
      (toggleDropdown)="toggleStatusDropdown()"></app-filter-multi-select>
    <app-filter-multi-select
      [label]="{ titleAr: 'الفترات', titleEn: 'Intervals' }"
      [items]="dispatchTimeOptions()"
      [(selectedIds)]="selectedDispatchTimeIds"
      [showDropdown]="showDispatchDropdown()"
      (toggleDropdown)="toggleDispatchDropdown()"></app-filter-multi-select>

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء (من)' : 'Creation From'"
      [value]="createdOnFrom()"
      (valueChange)="createdOnFrom.set($event)"
      [isInvalid]="createdDateInvalid()"></app-filter-date-component>
    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء (إلى)' : 'Creation To'"
      [value]="createdOnTo()"
      (valueChange)="createdOnTo.set($event)"
      [isInvalid]="createdDateInvalid()"></app-filter-date-component>
    <div></div>
    <app-filter-date-component
      [label]="isArabic() ? 'آخر تعديل (من)' : 'Modified From'"
      [value]="lastModifiedOnFrom()"
      (valueChange)="lastModifiedOnFrom.set($event)"
      [isInvalid]="lastModifiedDateInvalid()"></app-filter-date-component>
    <app-filter-date-component
      [label]="isArabic() ? 'آخر تعديل (إلى)' : 'Modified To'"
      [value]="lastModifiedOnTo()"
      (valueChange)="lastModifiedOnTo.set($event)"
      [isInvalid]="lastModifiedDateInvalid()"></app-filter-date-component>
  </div>

  <div class="flex justify-between pt-4">
    <app-filter-sorting-component
      [orderBy]="filters().orderBy!"
      (orderByChange)="filters().orderBy = $event"
      [orderDir]="filters().orderDir!"
      [sortOptions]="sortOptions()"
      (toggleOrder)="onToggleSortOrder()"></app-filter-sorting-component>

    <div class="flex items-end justify-end gap-3">
      <!-- <button
        (click)="onResetFilters()"
        class="rounded-[6px] border border-[#C42727] px-5 py-1.5 text-[13px] font-[500] text-[#C42727] hover:cursor-pointer hover:bg-red-50">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </button>
      <button
        (click)="onApplyFilters()"
        class="rounded-[6px] bg-[#C42727] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer hover:bg-[#a31f1f]">
        <span i18n="@@adminProductsApplyButton">Apply</span>
      </button> -->
         <app-submit-button type="secondary" (click)="onResetFilters()">
          <span i18n="@@adminProductsResetButton">Clear</span>
        </app-submit-button>

        <app-submit-button type="primary" (click)="onApplyFilters()">
          <span i18n="@@adminProductsApplyButton">Apply</span>
        </app-submit-button>

    </div>
  </div>
</div>
